import React, { useState } from "react";
import axios from "axios";
import { LOGIN_ENDPOINT } from "../api/endpoint";
import "./LoginForm.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveAuthData, saveUserData } from "../store/slice/loginSlice";
import Input from "../components/input";
import ResetPasswordModal from "./ResetPasswordModal";
import toast from "react-hot-toast";
import Loader from "../components/loader";
import bg from "../assests/images/tennis-court.webp";

const LoginForm = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateInputs = () => {
    const { email, password } = formData;

    // Ensure errors is always an object
    const newErrors = { ...errors };

    if (!email) {
      newErrors.email = "Email cannot be empty.";
    } else if (email.includes(" ")) {
      newErrors.email = "Email should not contain spaces.";
    }
    // else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
    //   newErrors.email = "Invalid Email"
    // }
    else {
      newErrors.email = "";
    }
    if (!password) {
      newErrors.password = "Password cannot be empty.";
    } else if (password.includes(" ")) {
      newErrors.password = "Password should not contain spaces.";
    } else {
      newErrors.password = "";
    }

    setErrors(newErrors);

    // If any error exists, validation fails
    return !newErrors.email && !newErrors.password;
  };

  const login = async (e) => {
    e.preventDefault();
    if (!validateInputs()) {
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(LOGIN_ENDPOINT, formData);
      const token = response.data.accessToken;
      dispatch(saveAuthData(token));
      navigate("/dashboard");
      dispatch(saveUserData(response?.data));
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err?.response?.data?.error_description);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="login-container"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="login-card">
          <h2 className="login-title">Welcome Back</h2>
          <p className="login-subtitle">Please log in to continue</p>
          <form onSubmit={login}>
            <div className="mb-2">
              <label className="mb-1 fw-semibold" style={{ letterSpacing: "1px" }}>
                Email <span className="text-danger">*</span>
              </label>
              <Input
                name="email"
                // label="Email"
                type="text"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required={true}
                lineHeight="2"
              />
              {errors?.email && (
                <div className="form-error-message">{errors?.email}</div>
              )}
            </div>
            <div className="mb-2">
              <label className="mb-1 fw-semibold" style={{ letterSpacing: "1px" }}>
                Password <span className="text-danger">*</span>
              </label>
              <Input
                name="password"
                type="password"
                // label="Password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required={true}
                lineHeight="2"
              />
              {errors?.password && (
                <div className="form-error-message">{errors?.password}</div>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="login-button mt-3 fw-bold"
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
          <div className="mt-3 text-center">
            <button
              className="btn link-secondary fw-semibold"
              onClick={() => setIsResetPasswordOpen(true)}
            >
              Forgot Password?
            </button>
          </div>
        </div>
      </div>
      <ResetPasswordModal
        isResetPasswordOpen={isResetPasswordOpen}
        closeModal={() => setIsResetPasswordOpen(false)}
      />
      {loading && <Loader />}
    </div>
  );
};

export default LoginForm;
